export type SaveErrorState = false | string | { message: string; persistent?: boolean };

export const GENERIC_SAVE_ERROR_MESSAGE = "We are having trouble saving your data. Please check your internet connection.";

/**
 * Maps the Story Bible saveError state to the toast that should be shown.
 * Persistent errors (e.g. Story Bible over the Firestore size limit) stay on
 * screen until dismissed or until a save succeeds; everything else keeps the
 * default auto-dismiss behavior.
 */
export const resolveSaveErrorToast = (saveError: SaveErrorState): { message: string; persistent: boolean } | null => {
  if (!saveError) {
    return null;
  }

  if (typeof saveError === "string") {
    return { message: saveError, persistent: false };
  }

  return { message: saveError.message || GENERIC_SAVE_ERROR_MESSAGE, persistent: Boolean(saveError.persistent) };
};
